import {css} from 'styled-components';

const StyledCustomScrollbar = css`
	overflow-y: auto;
	&::-webkit-scrollbar {
		height: 0.6rem;
		width: 0.6rem;
		border: none;
	}

	&::-webkit-scrollbar-track {
		background: #e7e7ea;
		height: 0.6rem;
		width: 0.6rem;
		border: none;
	}

	&::-webkit-scrollbar-thumb {
		background: var(--neutrals-300);
		height: 0.6rem;
		width: 0.6rem;
		cursor: pointer;
		border: none;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: #747480;
		border: none;
	}
`;

export default StyledCustomScrollbar;

export const customScrollbarClass = css`
	.customScrollbar {
		${StyledCustomScrollbar}
	}
`;
